import styled from 'styled-components'
import {
  PRIMARY_BLUE_02,
  GRAY_SCALE_09,
  GRAY_SCALE_05,
  SECONDARY_BLUE_02,
  GRAY_SCALE_10,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 32px;
`

export const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const EventTitle = styled.h3`
  color: ${PRIMARY_BLUE_02};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin: 0;
`

export const EventCategory = styled.span`
  color: ${GRAY_SCALE_05};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
  background-color: ${GRAY_SCALE_10};
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
  width: fit-content;
`

export const EventUrl = styled.a`
  color: ${SECONDARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-decoration: none;
  display: inline-block;
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }
`

export const EventTime = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${GRAY_SCALE_05};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`

export const VenueInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const VenueName = styled.h4`
  color: ${PRIMARY_BLUE_02};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`

export const VenueLocation = styled.span`
  color: ${GRAY_SCALE_05};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`

export const ArtistsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ArtistsTitle = styled.h4`
  color: ${PRIMARY_BLUE_02};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`

export const ArtistList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ArtistItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: ${WHITE};
  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 4px;
`

export const ArtistName = styled.span`
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

export const ArtistType = styled.span`
  color: ${GRAY_SCALE_05};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-transform: uppercase;
  background-color: ${GRAY_SCALE_10};
  padding: 4px 8px;
  border-radius: 4px;
`

export const TicketingInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const TicketingTitle = styled.h4`
  color: ${PRIMARY_BLUE_02};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`

export const PriceRange = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`

export const PriceItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const PriceLabel = styled.span`
  color: ${GRAY_SCALE_05};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const PriceValue = styled.span`
  color: ${PRIMARY_BLUE_02};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`